import { BARCODE_BORDER_COLOR_HEX, TICKET_BG_COLOR_HEX } from '../../wallet/wallet.constants';
import { TicketModel } from '@/v2/models/ticketModel';
import { ProductModel } from '@/v2/models/productModel';

export function getHeaderBackgroundColor(ticket: TicketModel): string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return ticket.bgColorHex;
}

export function getTextFontColor(ticket: TicketModel): string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return ticket.fontColorHex;
}

export function getTicketBackgroundColor(model: TicketModel | ProductModel): string | null {
  if (model.voidedAt != null) {
    return null;
  }
  return TICKET_BG_COLOR_HEX;
}

export function getBarcodeBorderColor(model: TicketModel | ProductModel): string | null {
  if (model.voidedAt != null) {
    return null;
  }
  return BARCODE_BORDER_COLOR_HEX;
}
